<template>
    <div>
      <CCard class="content-fade-in mt-3p5">
        <CCardHeader>
            <b>Cấu hình tốc độ đọc</b>
            <CRow class="mb-3 search-panel">
                <CCol xs="12" sm="6" md="6" lg="6" xl="2">
                <BaseInput :options="titleInput.options" :data="titleInput.data" :listener="titleInput.listener" />
                </CCol>
                <CCol>
                <div class="form-group">
                    <label style="color: white"></label>
                    <div style="margin-top: 10px">
                    <CButton style="float: right; margin-left: 5px; margin-top: 1px;" color="primary"
                        v-c-tooltip.hover="'Tải lại'" class="btn-action-primary" @click="loadDataMainTable(true)">
                        <i class="fa fa-refresh"></i>&nbsp; Tải lại
                    </CButton>
                    <CButton style="float: right; margin-left: 5px; margin-top: 1px;" color="primary"
                        v-c-tooltip.hover="'Thêm mới'" class="btn-action-primary"
                        @click="openPopupUpdate()">
                        <i class="fa fa-plus"></i>&nbsp; Thêm mới
                    </CButton>
                    </div>
                </div>
                </CCol>
            </CRow>
            <CRow class="row-2">
        
            </CRow>
        </CCardHeader>
        <CCardBody>
          <BaseTable :options="mainTable.options" :slots="mainTable.slots" :dataSource="mainTable.dataSource"
            ref="mainTable">
            <template #index="{ index }">
              <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
            </template>
  
            <template #action="{ item }">
              <td class="action-btn-group">
                <div class="action-btn-wrapper">
                  <CButton v-if="$hasAuthor('ROLE_ADMIN')" color="info" variant="outline" v-c-tooltip.hover="'Cập nhật'"
                    square size="sm" @click="loadDataById(item.id)">
                    <CIcon name="cil-pencil" />
                  </CButton>
                  <CButton v-if="$hasAuthor('ROLE_ADMIN')" color="danger" variant="outline" square size="sm"
                    v-c-tooltip.hover="'Xóa'" @click="setupSelectOneAction('delete_one', item.id, item.name)">
                    <CIcon name="cil-trash" />
                  </CButton>
                </div>
              </td>
            </template>
          </BaseTable>
        </CCardBody>

        <CModal :title="'Cập nhật tốc độ'" :show.sync="isShowModal" :closeOnBackdrop="false">
            <CRow class="pb-2">
                <CCol sm="12" md="12" xl="12" xs="12">
                    <BaseInput :options="dataSave.nameInput.options" :data="dataSave.nameInput.data"
                    :listener="dataSave.nameInput.listener" />
                </CCol>
                <CCol sm="12" md="12" xl="12" xs="12">
                    <BaseInput :options="dataSave.speedInput.options" :data="dataSave.speedInput.data"
                    :listener="dataSave.speedInput.listener" />
                </CCol>
            </CRow>
            <template v-slot:footer>
                <button type="button" class="btn btn-secondary" @click="isShowModal = false"><i class="fa fa-times"></i> Hủy bỏ
                </button>
                <button type="button" class="btn btn-primary" @click="submitData()"><i class="fa fa-save"></i>
                    Lưu lại
                </button>
            </template>
        </CModal>

      </CCard>
      <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping" ref="actionModal"></ModalConfirm>
  
      <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  
  
    </div>
  </template>
  
  <script>
  import BaseTable from "@/views/base/BaseDataTable";
  import ModalConfirm from "@/views/base/BaseModalConfirm";
  import BaseInput from "@/views/base/BaseInput";
  import BaseSelect from "@/views/base/BaseSelect2";
  import BaseFormLoading from "@/views/base/BaseFormLoading";
  import BaseModal from "@/views/base/BaseModal";
  import BaseSwitch from "@/views/base/BaseSwitch";
  
  export default {
    name: "ConfigTextToSpeechSpeedList",
    components: {
      BaseFormLoading,
      BaseTable,
      ModalConfirm,
      BaseInput,
      BaseSelect,
      BaseModal,
      BaseSwitch
    },
    props: {
      configId: String
    },
    notifications: {
      showSuccessMsg: {
        type: "success",
        title: "Success",
      },
      showErrorMsg: {
        type: "error",
        title: "Error",
      },
      showWarningMsg: {
        type: "warn",
        title: "warn",
      },
    },
    data() {
      let that = this;
      let actionTypeMapping = new Map();
      actionTypeMapping.set("delete_one", {
        url: "/text-to-speech-config/delete-speed-by-id",
        titlePopup: function () {
          return that.$helper.setupTitleAction(
            "xóa",
            "cấu hình",
            that.actionData.model.name
          );
        },
        isJsonContentType: false,
        dataSubmit: function () {
          return {
            id: that.actionData.model.id
          };
        },
        successCallback: function () {
          that.showSuccessMsg({ message: "Xóa cấu hình " + that.actionData.model.name + " thành công" });
          that.loadDataMainTable();
        }
      });
      return {
        labelIcon: {
          labelOn: '\u2713',
          labelOff: '\u2715'
        },
        isShowModal: false,
        loading: {
          value: false,
        },
        dataSave: {
          idField: {
            data: {
              name: "id",
              model: ""
            }
          },
          speedInput: {
            options: {
              label: "Tốc độ",
              placeholder: "Tốc độ",
              type: "number"
            },
            data: {
              name: "speed",
              model: "",
              updateCallback: function () {
                that.submitData();
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  return this.isValid;
                }
              }
            }
          },
          nameInput: {
            options: {
              label: "Tên",
              placeholder: "Tên",
            },
            data: {
              name: "name",
              model: "",
              updateCallback: function () {
                that.submitData();
              },
              validator: {
                isValid: true,
                errorMessage: "",
                valid: function () {
                  return this.isValid;
                }
              }
            }
          },
        },
        actionData: {
          actionTypeMapping: actionTypeMapping,
          model: {
            selectedAll: false,
            id: null,
            name: null
          }
        },
        titleInput: {
          options: {
            placeholder: "Tên cấu hình",
            label: "Tên cấu hình",
          },
          data: {
            name: "name",
            model: "",
            updateTrigger: function () {
              return that.$refs.mainTable;
            },
          },
        },
        mainTable: {
          options: {
            fields: [
              { key: "index", label: "STT", sorter: false, filter: false },
              { key: "name", label: "Tên" },
              { key: "speed", label: "Tốc độ" },
              { key: "action", label: "Thao tác", _classes: "action-sticky-group", _style: "", sorter: false, filter: false },
            ],
            slots: [
              "index", "createDate",  "action"
            ],
            pageSize: 5,
            sorter: true,
            columnFilter: false,
            itemsPerPageSelect: { label: ' ', values: [5, 10, 20], external: true },
            tableFilter: { label: 'Bộ lọc:', placeholder: 'Nhập ký tự cần tìm kiếm', external: false, lazy: true },
          },
          dataSource: {
            url: "/text-to-speech-config/get-speeds",
            dataSubmit: function () {
              var params = that.$helper.setupDataSubmit(that.$data);
              params.configId = that.configId;
              return params;
            },
            response: function (dataResponse) {
              return dataResponse.data;
            },
          },
        },
      };
    },
    methods: {
      loadDataMainTable: function (isUpdateFilter) {
        this.$refs.mainTable.loadData(true, isUpdateFilter);
      },
      setupSelectOneAction: function (actionTypeKey, id, name) {
        let actionData = this.actionData.model;
        actionData.id = id || null;
        actionData.name = name || null;
        this.$refs.actionModal.setCurrAction(actionTypeKey);
      },
  
      openPopupUpdate: function (id) {
        this.dataSave.idField.data.model = id;
        this.dataSave.speedInput.data.model = "";
        this.dataSave.nameInput.data.model = "";
        this.isShowModal = true;
      },
      loadDataById(id) {
        let that = this;
        that.isShowModal = true;
        this.$helper.loadDataSource({
          loading: that.loading,
          url: "/text-to-speech-config/find-speed-by-id",
          isJsonContentType: false,
          dataSubmit: function () {
            return {id: id}
          },
          successCallback: function (response) {
            that.isShowModal = true;
            that.$helper.setupDataResponse(that.$data.dataSave, response.data.data);
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          }
        });
      },
  
      submitData: function () {
        let that = this;
        let isValid = true;
        isValid &= this.dataSave.speedInput.data.validator.valid();
        isValid &= this.dataSave.nameInput.data.validator.valid();
        if (!isValid) {
          return;
        }
        let dataRequest = {
          id: this.dataSave.idField.data.model,
          speed: this.dataSave.speedInput.data.model,
          name: this.dataSave.nameInput.data.model,
          configId: this.configId
        }
        this.$helper.loadDataSource({
          loading: that.loading,
          url: "/text-to-speech-config/update-speed",
          dataSubmit: function () {
            return dataRequest;
          },
          successCallback: function (response) {
            if (!that.$helper.validResponse(that.$router, response.data)) {
              that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
              that.$helper.setupErrorModel(response.data.data, that.$data);
            } else {
              that.showSuccessMsg({
                message: "Cập nhật cấu hình thành công"
              });
              that.isShowModal = false;
              that.loadDataMainTable();
            }
          },
          errorCallback: function (error) {
            that.$helper.handleError(that.$router, error);
          }
        });
      },
    },
    created: function () {
    },
    mounted() {
    },
    watch: {
    },
    computed: {},
  };
  </script>
  <style scoped>
  .td-roles {
    max-width: 250px;
  }
  </style>
  <style>
  .row-2 .form-group {
    margin-top: 0 !important;
  }
  </style>